import { IcoArchive, IcoFolder, IcoSend } from "./icons";

export type HomeTab = "folders" | "subs" | "archives";

export function HomeToggle({
  tab,
  onTab,
}: {
  tab: HomeTab;
  onTab: (t: HomeTab) => void;
}) {
  return (
    <div className="sg-switch" role="tablist" aria-label="Vue d’accueil">
      <button
        type="button"
        role="tab"
        aria-selected={tab === "folders"}
        className={tab === "folders" ? "is-on" : ""}
        onClick={() => onTab("folders")}
      >
        <IcoFolder />
        Dossier
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={tab === "subs"}
        className={tab === "subs" ? "is-on" : ""}
        onClick={() => onTab("subs")}
      >
        <IcoSend />
        Soumissions
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={tab === "archives"}
        className={tab === "archives" ? "is-on" : ""}
        onClick={() => onTab("archives")}
      >
        <IcoArchive />
        Archives
      </button>
    </div>
  );
}
